/** @format */

import { createContext } from 'react';

export const EventContext = createContext({
  matches: [],
  match: {},
  posts: [],
  post: {},
  ages: [],
  age: {},
  sports: [],
  levels: [],
  level: {},
  matchStyles: [],
  matchStyle: {},
  matchKinds: [],
  allowProvinces: [],
  matchPosts: [],
  matchAges: [],
  registers: [],
  roles: [],
  role: {},
  permissions: [],
  permission: {},
  users: [],
  user: {},
  countries: [],
  provinces: [],
  cities: [],
  citiesBirth: [],
  citiesIssuing: [],
  factors: [],
  factor: {},
  transactions: [],
  transaction: {},
  statuses: [],
  events: [],
  eventsImportant: [],
  event: {},
  fields: [],
  forms: [],
  form: {},
  formBuilderFieldsData: [],
  authUser: {},
  authRoles: [],
  supervisor: {},
  organizers: [],
  organizer: {},
  categories: [],
  category: {},
  teams: [],
  team: {},
  exports: [],
  sportFields: [],
  sportField: [],
  idCards: [],
  userPermissions: [],
  idCard: {},
  idCardFields: {
    fields: [],
    width: '',
    height: '',
    font_size: 12,
    background_image: '',
    background_color: '',
    title: '',
    signature: {},
    qrCode: {},
    event_id: {},
  },
});
